import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import MakeAPICall from "../../apiCalls/common";
import appRoutes from "../../routes/appRoutes";

import {
  getCouponListApiRoute,
  addNewCouponApiRoute,
  editCouponApiRoute,
  updateCouponStatusApiRoute,
  deleteCouponApiRoute
} from "../../apiRoutes";
import { sortData } from "../../utils/commonMethods";
import { getFormattedDate } from "../../utils/dateTimeHelper";

import Button from "../../components/button";
import CustomModal from "../../components/modal";
import Loader from "../../components/loader";
import CustomDataTable from "../../components/datatable/customDataTable";

import CouponForm from "../../containers/Coupons/couponForm";

const ViewCouponsListPage = props => {
  let history = useHistory();

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [couponsList, setCouponsList] = useState([]);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currFilters, setCurrFilters] = useState(
    props.location && props.location.state && props.location.state.currPageNo
      ? {
          skip: props.location.state.currPageNo.skip,
          limit: props.location.state.currPageNo.limit
        }
      : {
          skip: 0,
          limit: 10
        }
  );
  const [showTextModal, setShowTextModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [currSelCoupon, setCurrSelCoupon] = useState(null);
  const [showUnblockModal, setShowUnblockModal] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const tableHeaders = [
    {
      key: "code",
      value: "Coupon"
    },
    { key: "expiryDate", value: "Expiry Date" },
    { key: "oneTimeUse", value: "One Time Use" },
    { key: "action", value: "Action" },
    { key: "amount", value: "Discount" }
  ];

  const goToCouponDetailPage = id => {
    history.push(appRoutes.viewCouponDetail + "/" + id, {
      currPageNo: currFilters
    });
  };

  const toggleCouponModal = () => {
    setShowCouponModal(!showCouponModal);
  };

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.skip = filters.skip;
    newFilter.text = filters.text;
    setCurrFilters(newFilter);
  };

  // const sortTableDataByColumn = SelColumn => {
  //   let sortedData = sortData(SelColumn.column, SelColumn.order, couponsList);
  //   setCouponsList(sortedData);
  // };

  const getCouponsList = () => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: getCouponListApiRoute,
      params: currFilters,
      successCallback: async res => {
        
        let list = [];
        await res.data.data.couponsList.forEach(item => {
          let dt = {};
          dt.id = item._id;
          dt.status = item.isActive;
          dt.code = item.code;
          dt.expiryDate = item.expiryDate;
          dt.oneTimeUseBool = item.oneTimeUse;
          dt.oneTimeUse = item.oneTimeUse === true ? "Yes" : "No";
          dt.amount = item.amount;
          dt.isActive = item.isActive;
          dt.isPercent = item.isPercent;
          dt.couponTypes = item.couponTypes;

          list.push(dt);
        });
        setCouponsList(list);
        setTotalRecords(res.data.data.totalCount);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  useEffect(() => {
    getCouponsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  const addNewCoupon = data => {
    setShowCouponModal(false);
    setIsProcessing(true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: addNewCouponApiRoute,
      dataObj: data,
      params: {},
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Coupon Added Successfully");
        setShowTextModal(true);
        getCouponsList();
      },
      failureCallback: err => {
        setIsProcessing(false);

        if (err.message === "Coupon Already exists with this text") {
          setModalText("Coupon Already exists with this text");
        } else if(err && err.message){
          setModalText (err.message );
        }else {
          setModalText(
            "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          );
        }

        setShowTextModal(true);
      },
      showErrPopup: false
    });
  };

  const editCoupon = data => {
    setShowCouponModal(false);
    setIsProcessing(true);
    setCurrSelCoupon(null);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: editCouponApiRoute,
      dataObj: data,
      params: {},
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Coupon Updated Successfully");
        setShowTextModal(true);
        setCurrSelCoupon(null);
        getCouponsList();
      },
      failureCallback: err => {
        setIsProcessing(false);
       // setCurrSelCoupon(null);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );

        // setShowTextModal(true);
      }
    });
  };

  const updateCouponStatus = (id, status) => {
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("id", id);
    formData.append("status", status);

    let successText = "Coupon Enabled Successfully";

    if (status === false) {
      successText = "Coupon Disabled Successfully";
    }

    setApiCallParams({
      reqType: "PUT",
      reqUrl: updateCouponStatusApiRoute,
      dataObj: formData,
      params: {},
      successCallback: res => {
        setIsProcessing(false);
        setModalText(successText);
        setShowTextModal(true);
        setCurrSelCoupon(null);
        getCouponsList();
      },
      failureCallback: err => {
        setIsProcessing(false);
       // setCurrSelCoupon(null);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );

        // setShowTextModal(true);
      }
    });
  };

  const deleteCoupon = () => {
    setShowDeleteModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("id", currSelCoupon.id);

    setApiCallParams({
      reqType: "DELETE",
      reqUrl: deleteCouponApiRoute,
      dataObj: formData,
      params: {},
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Coupon Deleted Successfully");
        setShowTextModal(true);
        setCurrSelCoupon(null);
        getCouponsList();
      },
      failureCallback: err => {
        setIsProcessing(false);
        setCurrSelCoupon(null);
        if (err.message === "This coupon is being used by the patient") {
          setModalText("This coupon has been used by a patient");
        } else if(err && err.message){
          setModalText (err.message );
        } else {
          setModalText(
            "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          );
        }

         setShowTextModal(true);
      },
      showErrPopup  : false
    });
  };

  return (
    <div className="view-ticket-container">
      <CustomModal
        title="Instant Consult"
        useOneButton={true}
        cancelText="OKAY"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
      />
      <CustomModal
        title="Instant Consult"
        okayText="Yes"
        cancelText="No"
        openModal={showUnblockModal}
        cancelEvent={() => {
          setShowUnblockModal(false);
          setCurrSelCoupon(null);
        }}
        okayEvent={e => {
          setShowUnblockModal(false);
          updateCouponStatus(currSelCoupon.id, true);
        }}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to enable this coupon?
          </p>
        }
      />
      <CustomModal
        title="Instant Consult"
        okayText="Yes"
        cancelText="No"
        openModal={showBlockModal}
        cancelEvent={() => {
          setShowBlockModal(false);
          setCurrSelCoupon(null);
        }}
        okayEvent={e => {
          setShowBlockModal(false);
          updateCouponStatus(currSelCoupon.id, false);
        }}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to disable this coupon?
          </p>
        }
      />
      <CustomModal
        title="Instant Consult"
        okayText="Yes"
        cancelText="No"
        openModal={showDeleteModal}
        cancelEvent={() => {
          setShowDeleteModal(false);
          setCurrSelCoupon(null);
        }}
        okayEvent={deleteCoupon}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete this coupon?
          </p>
        }
      />
      <CustomModal
        className="modal-lg"
        openModal={showCouponModal}
        title={currSelCoupon !== null ? "Edit Coupon" : "Add New Coupon"}
        modalBodyContent={
          <CouponForm
            cancelEvent={() => {
              toggleCouponModal();
              setCurrSelCoupon(null);
            }}
            onAddSubmit={addNewCoupon}
            onEditCoupon={editCoupon}
            data={currSelCoupon}
            isEditMode={currSelCoupon !== null}
          />
        }
        noFooterButtons={true}
      />
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="d-flex flex-row flex-wrap justify-content-between">
          <h3>Coupons</h3>
          <div className="d-flex flex-row align-items-end">
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button clickEvent={toggleCouponModal} title="Add Coupon"></Button>
          </div>
        </div>
        <CustomDataTable
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortableTable={false}
          // sortData={sortTableDataByColumn}
          tabFilters={currFilters}
        >
          {couponsList.map((item, index) => (
            <tr
              key={index}
              onClick={e => {
                e.preventDefault();
                goToCouponDetailPage(item.id);
              }}
            >
              <td>{item.code}</td>
              <td>{getFormattedDate(item.expiryDate)}</td>
              <td>{item.oneTimeUse}</td>
              <td>
                <div className="d-flex flex-row align-items-center">
                  <button
                    type="button"
                    className="btn btn-out-bell ml-2"
                    onClick={e => {
                      e.stopPropagation();
                      setCurrSelCoupon(item);
                      toggleCouponModal();
                    }}
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  {item.status === true && (
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        setCurrSelCoupon(item);
                        setShowBlockModal(true);
                      }}
                      type="button"
                      className="btn btn-out-green ml-2"
                    >
                      <i className="fas fa-lock-open"></i>
                    </button>
                  )}
                  {item.status === false && (
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        setCurrSelCoupon(item);
                        setShowUnblockModal(true);
                      }}
                      type="button"
                      className="btn btn-out-delete ml-2"
                    >
                      <i className="fas fa-lock"></i>
                    </button>
                  )}

                  <button
                    onClick={e => {
                      e.stopPropagation();
                      setCurrSelCoupon(item);
                      setShowDeleteModal(true);
                    }}
                    type="button"
                    className="btn btn-out-delete ml-2"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </div>
              </td>
              {/* <td>{item.isPercent? "Percent" : "Amount"}</td> */}
              <td>{`${item.isPercent ? '': '$'}${item.isPercent ? item.amount : item.amount.toFixed(2)}${item.isPercent ? '%': ''} Off`}</td>
            </tr>
          ))}
        </CustomDataTable>
        {/* API Call */}
        <MakeAPICall apiParam={apiCallParams} />
      </div>
    </div>
  );
};

export default ViewCouponsListPage;
